import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { isDev } from 'Utilities/helpers';

export interface SavedFiltersActionsStoreState {
	isHoveringSavedSearchesChip: boolean;
	isLoadingFilter?: boolean;
	lastActiveFilterBeforeEdit?: number;
	setIsHoveringSavedSearchesChip: (isHoveringSavedSearchesChip: boolean) => void;
	setIsLoadingFilter: (isLoadingFilter: boolean) => void;
	setLastActiveFilterBeforeEdit: (filterId: number | undefined) => void;
}

const savedFiltersActionsStore = devtools<SavedFiltersActionsStoreState>(
	(set) => ({
		isHoveringSavedSearchesChip: false,
		isLoadingFilter: false,
		lastActiveFilterBeforeEdit: undefined,
		setIsHoveringSavedSearchesChip: (isHoveringSavedSearchesChip: boolean) => {
			set({ isHoveringSavedSearchesChip }, false, { type: 'setIsHoveringSavedSearchesChip' });
		},
		setIsLoadingFilter: (isLoadingFilter: boolean) => {
			set({ isLoadingFilter }, false, { type: 'setIsLoadingFilter' });
		},
		setLastActiveFilterBeforeEdit: (filterId: number | undefined) => {
			set({ lastActiveFilterBeforeEdit: filterId }, false, { filterId, type: 'setLastActiveFilterBeforeEdit' });
		},
	}),
	{
		enabled: Boolean(isDev),
		name: 'SavedFiltersActionsStore',
	},
);

const useSavedFiltersActionsStore = create(savedFiltersActionsStore);

export const useSetIsHoveringSavedSearchesChip = (): SavedFiltersActionsStoreState['setIsHoveringSavedSearchesChip'] =>
	useSavedFiltersActionsStore((store) => store.setIsHoveringSavedSearchesChip);
export const useIsHoveringSavedSearchesChip = (): SavedFiltersActionsStoreState['isHoveringSavedSearchesChip'] =>
	useSavedFiltersActionsStore((store) => store.isHoveringSavedSearchesChip);
export const useSetLastActiveFilterBeforeEdit = (): SavedFiltersActionsStoreState['setLastActiveFilterBeforeEdit'] =>
	useSavedFiltersActionsStore((store) => store.setLastActiveFilterBeforeEdit);
export const useLastActiveFilterBeforeEdit = (): SavedFiltersActionsStoreState['lastActiveFilterBeforeEdit'] =>
	useSavedFiltersActionsStore((store) => store.lastActiveFilterBeforeEdit);
export const useSetIsLoadingFilter = (): SavedFiltersActionsStoreState['setIsLoadingFilter'] =>
	useSavedFiltersActionsStore((store) => store.setIsLoadingFilter);
export const useIsLoadingFilter = (): SavedFiltersActionsStoreState['isLoadingFilter'] =>
	useSavedFiltersActionsStore((store) => store.isLoadingFilter);

export default useSavedFiltersActionsStore;
